export default __webpack_public_path__ + "static/media/07AW3SEP66.6ded1a8f.jpg";